import { Outlet } from 'react-router-dom';

import NavSite from '../component/nav-site';

export default function Root() {
    return (
        <>
            <NavSite />

            <div className='mt-1'>
                <Outlet />
            </div>
        </>
    );
}
